<template>
  <div>
    <navMenu />
    
    <hero :heroTitle="$t('nav.kidsCoursesBtn')" class="pb-0"/>

    <section class="jsk-block pt-0">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2 col-md-12 text-center">
            <p class="mt-4 mb-5">{{ $t("cta.coursesText") }}</p>
            <coursesCtaBtns />
          </div>
        </div>
      </div>
    </section>

    <modules 
    :moduleZeroPrice='$t("coursesPage.moduleZeroPrice")'
    :moduleOnePrice='$t("coursesPage.moduleOnePrice")'
    :moduleTwoPrice='$t("coursesPage.moduleTwoPrice")'
    :moduleThreePrice='$t("coursesPage.moduleThreePrice")'
    />

    <cta :ctaText="$t('cta.homeText')" :ctaBtn="$t('nav.registerBtn')" :ctaRoute="'/register'"/>
    <featured />

    <footerJSK />
  </div>
</template>

<script>
import navMenu from "./../components/navMenu.vue";
import modules from "./../components/modules.vue";
import footerJSK from "./../components/footer.vue";
import hero from "./../components/hero.vue";
import cta from "./../components/cta.vue";
import featured from "./../components/featured.vue";
import coursesCtaBtns from "./../components/coursesCtaBtns.vue"

export default {
  name: "Courses",
  components: {
    navMenu,
    hero,
    modules,
    cta,
    featured,
    coursesCtaBtns,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>
